import PptxGenJS from 'pptxgenjs';
import api from './axios';
import { normalizeDateForComparison } from '../constantes';

export const gerarApresentacao = async (filters: any = {}, isPreview: boolean = false) => {
  const pptx = new PptxGenJS();
  let yearLabel = new Date().getFullYear().toString();

  if (filters?.startDate) {
    const start = new Date(filters.startDate + 'T00:00:00');
    yearLabel = start.getFullYear().toString();
  }

  const payload = {
    distId: filters.distId || filters.distributorId,
    operacao: filters.operacao,
    gestor: filters.gestor,
    year: filters.year,
    month: filters.month,
    startDate: filters.startDate ? normalizeDateForComparison(filters.startDate) : null,
    endDate: filters.endDate ? normalizeDateForComparison(filters.endDate) : null,
    categoria: filters.categoria,
    marca: filters.marca
  };

  let quadrantes: any = {};
  let tabelaDistribuidores: any[] = [];
  let estoquePorDistribuidor: any[] = [];

  try {
    const response = await api.post('/get/apresentacao-geral', payload);
    const data = response.data?.data || response.data || {};
    quadrantes = data.quadrantes || {};
    tabelaDistribuidores = data.tabelaDistribuidores || [];
    estoquePorDistribuidor = data.estoquePorDistribuidor || [];


  } catch (error) {
    console.error('Erro ao buscar dados para apresentação geral:', error);
  }

  // Preenche dados padrão caso falte alguma categoria no retorno
  const getQuad = (key: string) => quadrantes[key] || { selloutAtual: 0, selloutMA: 0, cobAtual: 0, cobMA: 0, metaAtual: 0, metaMA: 0 };

  const geralData = getQuad('geral');
  const macarraoData = getQuad('macarrao');
  const refreskant1LData = getQuad('refreskant1L');
  const refreskant5LData = getQuad('refreskant5L');
  const refreskant10LData = getQuad('refreskant10L');
  const donaRaizData = getQuad('donaRaiz');
  const snacksData = getQuad('snacks');
  const temperoPoData = getQuad('temperoEmPo');

  if (isPreview) {
    const buildRow = (label: string, quadData: any) => {
      const sa = quadData.selloutAtual || 0;
      const sma = quadData.selloutMA || 0;
      const ca = quadData.cobAtual || 0;
      const cma = quadData.cobMA || 0;
      const m = quadData.metaAtual || 0;

      const gapMxM = sa - sma;
      const gapPct = sma > 0 ? (sa / sma) - 1 : 0;
      const gapCob = ca - cma;

      return {
        categoria: label,
        selloutMA: sma,
        selloutAtual: sa,
        gapMxM,
        gapPct: (gapPct * 100).toFixed(1) + '%',
        cobMA: cma,
        cobAtual: ca,
        gapCob,
        meta: m
      };
    };

    return [
      buildRow('Sellout Geral', geralData),
      buildRow('Macarrão', macarraoData),
      buildRow('Refreskant 1L', refreskant1LData),
      buildRow('Refreskant 5L', refreskant5LData),
      buildRow('Refreskant 10L', refreskant10LData),
      buildRow('Dona Raiz', donaRaizData),
      buildRow('Snacks', snacksData),
      buildRow('Tempero em Pó', temperoPoData)
    ];
  }

  pptx.layout = 'LAYOUT_16x9';

  const generateGradientImage = () => {
    if (typeof document === 'undefined') return '';
    const canvas = document.createElement('canvas');
    canvas.width = 1920;
    canvas.height = 1080;
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';

    // Linear gradient matching CSS (11% to 100% top to bottom)
    const grad = ctx.createLinearGradient(0, 0, 0, 1080);
    grad.addColorStop(0.11, '#002B80');
    grad.addColorStop(1, '#001842');

    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, 1920, 1080);

    // pptxgenjs expects "image/png;base64,..." without the "data:" prefix
    return canvas.toDataURL('image/png').replace(/^data:/, '');
  };

  const bgGradient = { data: generateGradientImage() };
  const headerColor = '8CB369'; // Green from screenshots
  const titleColor = 'CCFF00'; // Yellow-green from screenshots
  const tableCellColor = 'FFFFFF';
  const tableHeaderColColor = 'E2E6E9';
  const borderColor = 'D1D5DB';

  // Helper to create a standard 4-row table used in quadrants
  const createStandardTable = (data: { selloutAtual?: number, selloutMA?: number, cobAtual?: number, cobMA?: number, metaAtual?: number, metaMA?: number }) => {
    const selloutAtual = data.selloutAtual || 0;
    const selloutMA = data.selloutMA || 0;
    const cobAtual = data.cobAtual || 0;
    const cobMA = data.cobMA || 0;
    const metaAtual = data.metaAtual || 0;
    const metaMA = data.metaMA || 0;

    const gapMxM = selloutAtual - selloutMA;
    const gapPct = selloutMA > 0 ? (selloutAtual / selloutMA) - 1 : 0;
    const gapCob = cobAtual - cobMA;

    const gapMetaAtual = metaAtual > 0 ? (selloutAtual / metaAtual) - 1 : 0;
    const gapMetaMA = metaMA > 0 ? (selloutMA / metaMA) - 1 : 0;

    const formatValue = (val: number) => val.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    const formatPct = (val: number) => (val * 100).toFixed(1) + '%';
    const formatHeader = (text: string) => ({
      text,
      options: { fill: { color: headerColor }, color: '000000', fontSize: 8, align: 'center' as const, valign: 'middle' as const, bold: true, border: { pt: 1, color: borderColor } }
    });

    const formatRowHeader = (text: string) => ({
      text,
      options: { fill: { color: tableHeaderColColor }, color: '000000', fontSize: 8, align: 'left' as const, valign: 'middle' as const, bold: true, border: { pt: 1, color: borderColor } }
    });

    const formatCell = (text: string) => ({
      text,
      options: { fill: { color: tableCellColor }, color: '000000', fontSize: 8, align: 'center' as const, valign: 'middle' as const, border: { pt: 1, color: borderColor } }
    });

    return [
      [
        { text: '', options: { fill: { color: tableHeaderColColor }, border: { pt: 1, color: borderColor } } },
        formatHeader('SELLOUT (MA)'),
        formatHeader('SELLOUT'),
        formatHeader('GAP MxM'),
        formatHeader('GAP MA (%)'),
        formatHeader('Cobertura (MA)'),
        formatHeader('Cobertura'),
        formatHeader('Gap Cob')
      ],
      [
        formatRowHeader(yearLabel),
        formatCell(formatValue(selloutMA)),
        formatCell(formatValue(selloutAtual)),
        formatCell(formatValue(gapMxM)),
        formatCell(formatPct(gapPct)),
        formatCell(formatValue(cobMA)),
        formatCell(formatValue(cobAtual)),
        formatCell(formatValue(gapCob))
      ],
      [
        formatRowHeader('META'),
        formatCell(formatValue(metaMA)),
        formatCell(formatValue(metaAtual)),
        formatCell('-'),
        formatCell('-'),
        formatCell('-'),
        formatCell('-'),
        formatCell('-')
      ],
      [
        formatRowHeader('GAP META (%)'),
        formatCell(formatPct(gapMetaMA)),
        formatCell(formatPct(gapMetaAtual)),
        formatCell('-'),
        formatCell('-'),
        formatCell('-'),
        formatCell('-'),
        formatCell('-')
      ]
    ];
  };

  // ---------------------------------------------------------
  // Configurações Comuns das Tabelas Largas (1x2)
  // ---------------------------------------------------------
  const tableWidth = 9.0;
  const tableX = 0.5; // Centralizado
  const colWidths = [1.0, 1.5, 1.5, 1.2, 0.8, 1.3, 1.0, 0.7];

  // ---------------------------------------------------------
  // SLIDE 1 (Geral / Macarrão)
  // ---------------------------------------------------------
  const slide1 = pptx.addSlide();
  slide1.background = bgGradient;

  slide1.addText('Acompanhamento de Sellout', {
    x: 0, y: 0.2, w: '100%', h: 0.5,
    align: 'center', fontSize: 24, bold: true, color: titleColor
  });

  slide1.addText('Sellout Geral', { x: tableX, y: 1.0, w: tableWidth, align: 'center', fontSize: 14, bold: true, color: titleColor });
  slide1.addTable(createStandardTable(geralData), { x: tableX, y: 1.4, w: tableWidth, colW: colWidths });

  slide1.addText('Macarrão', { x: tableX, y: 3.4, w: tableWidth, align: 'center', fontSize: 14, bold: true, color: titleColor });
  slide1.addTable(createStandardTable(macarraoData), { x: tableX, y: 3.8, w: tableWidth, colW: colWidths });

  // ---------------------------------------------------------
  // SLIDE 2 (Refreskant 1L / Refreskant 5L)
  // ---------------------------------------------------------
  const slide2 = pptx.addSlide();
  slide2.background = bgGradient;

  slide2.addText('Acompanhamento de Sellout', {
    x: 0, y: 0.2, w: '100%', h: 0.5,
    align: 'center', fontSize: 24, bold: true, color: titleColor
  });

  slide2.addText('Refreskant 1L', { x: tableX, y: 1.0, w: tableWidth, align: 'center', fontSize: 14, bold: true, color: titleColor });
  slide2.addTable(createStandardTable(refreskant1LData), { x: tableX, y: 1.4, w: tableWidth, colW: colWidths });

  slide2.addText('Refreskant 5L', { x: tableX, y: 3.4, w: tableWidth, align: 'center', fontSize: 14, bold: true, color: titleColor });
  slide2.addTable(createStandardTable(refreskant5LData), { x: tableX, y: 3.8, w: tableWidth, colW: colWidths });

  // ---------------------------------------------------------
  // SLIDE 3 (Refreskant 10L / Dona Raiz)
  // ---------------------------------------------------------
  const slide3 = pptx.addSlide();
  slide3.background = bgGradient;

  slide3.addText('Acompanhamento de Sellout', {
    x: 0, y: 0.2, w: '100%', h: 0.5,
    align: 'center', fontSize: 24, bold: true, color: titleColor
  });

  slide3.addText('Refreskant 10L', { x: tableX, y: 1.0, w: tableWidth, align: 'center', fontSize: 14, bold: true, color: titleColor });
  slide3.addTable(createStandardTable(refreskant10LData), { x: tableX, y: 1.4, w: tableWidth, colW: colWidths });

  slide3.addText('Dona Raiz', { x: tableX, y: 3.4, w: tableWidth, align: 'center', fontSize: 14, bold: true, color: titleColor });
  slide3.addTable(createStandardTable(donaRaizData), { x: tableX, y: 3.8, w: tableWidth, colW: colWidths });

  // ---------------------------------------------------------
  // SLIDE 4 (Snacks / Tempero em Pó)
  // ---------------------------------------------------------
  const slide4 = pptx.addSlide();
  slide4.background = bgGradient;

  slide4.addText('Acompanhamento de Sellout', {
    x: 0, y: 0.2, w: '100%', h: 0.5,
    align: 'center', fontSize: 24, bold: true, color: titleColor
  });

  slide4.addText('Snacks', { x: tableX, y: 1.0, w: tableWidth, align: 'center', fontSize: 14, bold: true, color: titleColor });
  slide4.addTable(createStandardTable(snacksData), { x: tableX, y: 1.4, w: tableWidth, colW: colWidths });

  slide4.addText('Tempero em Pó', { x: tableX, y: 3.4, w: tableWidth, align: 'center', fontSize: 14, bold: true, color: titleColor });
  slide4.addTable(createStandardTable(temperoPoData), { x: tableX, y: 3.8, w: tableWidth, colW: colWidths });


  // ---------------------------------------------------------
  // SLIDE 5+ (Distribuidores)
  // ---------------------------------------------------------
  const formatHeader3 = (text: string) => ({
    text,
    options: { fill: { color: headerColor }, color: '000000', fontSize: 7, align: 'center' as const, valign: 'middle' as const, bold: true, border: { pt: 1, color: borderColor } }
  });

  const formatCell3 = (text: string, fillColor: string = tableCellColor) => ({
    text,
    options: { fill: { color: fillColor }, color: '000000', fontSize: 7, align: 'center' as const, valign: 'middle' as const, border: { pt: 1, color: borderColor } }
  });

  const formatNumberLocal = (val: number) => val.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  const distTableRows = tabelaDistribuidores
    .filter((dAtual: any) => (dAtual.selloutAtual || 0) > 0)
    .sort((a: any, b: any) => (b.selloutAtual || 0) - (a.selloutAtual || 0))
    .map((dAtual: any, index: number) => {
      const sellAtual = dAtual.selloutAtual || 0;
      const sellMA = dAtual.selloutMA || 0;
      const gapMxM = sellAtual - sellMA;
      const gapPct = sellMA === 0 ? 0 : ((sellAtual / sellMA) - 1) * 100;

      const cobAtual = dAtual.cobAtual || 0;
      const cobMA = dAtual.cobMA || 0;
      const gapCob = cobAtual - cobMA;

      const metaAtual = dAtual.metaAtual || 0;
      const gapMetaPct = metaAtual === 0 ? 0 : ((sellAtual / metaAtual) - 1) * 100;

      let ultimaAtu = '-';
      if (dAtual.ultimaVenda) {
        const parts = dAtual.ultimaVenda.split('-');
        if (parts.length === 3) {
          ultimaAtu = `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
      }

      const rowColor = index % 2 === 0 ? tableCellColor : 'F4F4F4';

      return [
        { text: `${index + 1}`, options: { fill: { color: tableHeaderColColor }, color: '000000', fontSize: 7, align: 'center' as const, border: { pt: 1, color: borderColor } } },
        formatCell3(dAtual.nome || `Distribuidor ${dAtual.id}`, rowColor),
        formatCell3(formatNumberLocal(sellMA), rowColor),
        formatCell3(formatNumberLocal(sellAtual), rowColor),
        formatCell3(formatNumberLocal(gapMxM), rowColor),
        formatCell3(`${gapPct > 0 ? '+' : ''}${gapPct.toFixed(1)}%`, rowColor),
        formatCell3(formatNumberLocal(metaAtual), rowColor),
        formatCell3(`${gapMetaPct > 0 ? '+' : ''}${gapMetaPct.toFixed(1)}%`, rowColor),
        formatCell3(formatNumberLocal(cobMA), rowColor),
        formatCell3(formatNumberLocal(cobAtual), rowColor),
        formatCell3(formatNumberLocal(gapCob), rowColor),
        formatCell3('', rowColor),
        formatCell3(ultimaAtu, rowColor)
      ];
    });

  if (distTableRows.length === 0) {
    distTableRows.push([
      formatCell3('-'), formatCell3('Nenhum dado'), formatCell3('-'), formatCell3('-'),
      formatCell3('-'), formatCell3('-'), formatCell3('-'), formatCell3('-'), formatCell3('-'),
      formatCell3('-'), formatCell3('-'), formatCell3(''), formatCell3('-')
    ]);
  }

  const distTableHeaders = [
    formatHeader3(''), formatHeader3('Distribuidor'), formatHeader3('SELLOUT (MA)'), formatHeader3('SELLOUT'),
    formatHeader3('GAP MxM'), formatHeader3('GAP MA (%)'), formatHeader3('META'), formatHeader3('GAP META (%)'), formatHeader3('Cobertura (MA)'), formatHeader3('Cobertura'), formatHeader3('Gap Cob'),
    formatHeader3('Informação / Observação'), formatHeader3('Ultima Atualização')
  ];

  const chunkSize = 16;
  for (let i = 0; i < distTableRows.length; i += chunkSize) {
    const chunk = distTableRows.slice(i, i + chunkSize);

    const slideDist = pptx.addSlide();
    slideDist.background = bgGradient;

    slideDist.addText('Acompanhamento de Sellout', {
      x: 0, y: 0.2, w: '100%', h: 0.5,
      align: 'center', fontSize: 24, bold: true, color: titleColor
    });

    slideDist.addText('Distribuidores e Observações', { x: 0.3, y: 0.8, w: 9.4, align: 'center', fontSize: 12, bold: true, color: titleColor });

    const distTable = [
      distTableHeaders,
      ...chunk
    ];

    slideDist.addTable(distTable, { x: 0.1, y: 1.2, w: 9.8, autoPage: false, colW: [0.3, 1.2, 0.7, 0.7, 0.7, 0.7, 0.6, 0.8, 0.8, 0.7, 0.6, 1.2, 0.8] });
  }

  // ---------------------------------------------------------
  // SLIDE Estoque
  // ---------------------------------------------------------
  const estoqueTableRows = estoquePorDistribuidor
    .filter((dist: any) => (dist.estoqueAtualCaixas || 0) > 0)
    .sort((a: any, b: any) => (b.estoqueAtualCaixas || 0) - (a.estoqueAtualCaixas || 0))
    .map((dist: any, index: number) => {
      const totalSellout3m = dist.sellout3MesesCaixas || 0;
      const dailyAvg = totalSellout3m / 90;
      let diasCalculados = 0;

      if (dailyAvg > 0) {
        diasCalculados = (dist.estoqueAtualCaixas || 0) / dailyAvg;
      }

      const rowColor = index % 2 === 0 ? tableCellColor : 'F4F4F4';

      return [
        { text: `${index + 1}`, options: { fill: { color: tableHeaderColColor }, color: '000000', fontSize: 7, align: 'center' as const, valign: 'middle' as const, border: { pt: 1, color: borderColor } } },
        formatCell3(dist.nome || `Distribuidor ${dist.distId}`, rowColor),
        formatCell3(Math.round(dist.estoqueAtualCaixas || 0).toLocaleString('pt-BR'), rowColor),
        formatCell3(Math.round(diasCalculados).toString(), rowColor)
      ];
    });

  if (estoqueTableRows.length === 0) {
    estoqueTableRows.push([
      { text: '-', options: { fill: { color: tableHeaderColColor }, color: '000000', fontSize: 7, align: 'center' as const, valign: 'middle' as const, border: { pt: 1, color: borderColor } } },
      formatCell3('Sem dados'), formatCell3('-'), formatCell3('-')
    ]);
  }

  const estoqueTableHeaders = [
    { text: '', options: { fill: { color: headerColor }, border: { pt: 1, color: borderColor } } },
    formatHeader3('Distribuidor'), formatHeader3('Estoque Atual (Cx)'), formatHeader3('Dias')
  ];

  const chunkSizeEst = 16;
  for (let i = 0; i < estoqueTableRows.length; i += chunkSizeEst) {
    const chunk = estoqueTableRows.slice(i, i + chunkSizeEst);
    const slideEstoque = pptx.addSlide();
    slideEstoque.background = bgGradient;

    slideEstoque.addText('Acompanhamento de Sellout', {
      x: 0, y: 0.2, w: '100%', h: 0.5,
      align: 'center', fontSize: 24, bold: true, color: titleColor
    });

    slideEstoque.addText('Estoque', { x: 0, y: 0.8, w: '100%', align: 'center', fontSize: 12, bold: true, color: titleColor });

    const estoqueTable = [
      estoqueTableHeaders,
      ...chunk
    ];

    slideEstoque.addTable(estoqueTable, { x: 2.5, y: 1.2, w: 5.0, autoPage: false, colW: [0.5, 2.0, 1.25, 1.25] });
  }

  // ---------------------------------------------------------
  // SAVE
  // ---------------------------------------------------------
  await pptx.writeFile({ fileName: 'Apresentacao_Sellout.pptx' });
};
